import React from 'react';
import Button from '../../../components/base/Button';

export default function AboutSection() {
  const achievements = [
    {
      number: '300+',
      label: '累计服务客户',
      icon: 'ri-building-line'
    },
    {
      number: '800+万吨',
      label: '碳资产管理规模',
      icon: 'ri-database-line'
    },
    {
      number: '400+万吨',
      label: '减排量开发业绩',
      icon: 'ri-leaf-line'
    },
    {
      number: '18项',
      label: '软件著作权',
      icon: 'ri-award-line'
    }
  ];

  const values = [
    {
      title: '专业专注',
      description: '深耕低碳技术领域，提供专业的技术解决方案',
      icon: 'ri-focus-3-line'
    },
    {
      title: '创新驱动',
      description: '持续技术创新，引领行业发展趋势',
      icon: 'ri-lightbulb-line'
    },
    {
      title: '诚信服务',
      description: '以客户为中心，提供诚信可靠的服务',
      icon: 'ri-shield-check-line'
    },
    {
      title: '绿色发展',
      description: '致力于推动可持续发展和绿色未来',
      icon: 'ri-plant-line'
    }
  ];

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          {/* Left Content */}
          <div>
            <div className="inline-block px-4 py-2 bg-emerald-100 text-emerald-600 rounded-full text-sm font-medium mb-6">
              关于我们
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              引领企业走向
              <span className="text-emerald-600">绿色未来</span>
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              在国家"3060"战略大背景下，为充分发挥上市公司资本平台的优势和上海的人才优势，更好地承接国际和国内双碳业务，科创板上市公司复洁环保（688335.SH）联合行业资深团队，于2022年3月组建捷碳（上海）科技有限公司。
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              公司基于河南德能环保科技有限公司的技术积淀，旨在将其打造成行业领先的综合性双碳服务商。我们拥有一支专业的技术团队，在碳减排、能源管理、绿色发展等领域积累了丰富的经验，致力于为企业提供全方位的低碳技术解决方案。
            </p>
            <button 
              onClick={scrollToContact}
              className="whitespace-nowrap cursor-pointer font-medium transition-all duration-200 flex items-center justify-center bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-4 text-lg rounded-xl"
            >
              <i className="ri-team-line mr-2"></i>
              了解详情
            </button>
          </div>

          {/* Right Image */}
          <div className="relative">
            <img
              src="/src/assets/images/about-team.jpg"
              alt="关于我们"
              className="w-full rounded-2xl shadow-2xl object-cover object-top"
            />
            <div className="absolute -bottom-6 -left-6 bg-emerald-600 text-white p-6 rounded-xl shadow-lg">
              <div className="text-2xl font-bold">5年+</div>
              <div className="text-sm opacity-90">行业经验</div>
            </div>
          </div>
        </div>

        {/* Company History & Background */}
        <div className="bg-gray-50 rounded-3xl p-8 lg:p-12 mb-20">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">公司发展历程</h3>
            <p className="text-lg text-gray-600">从创新创业到行业领先的发展之路</p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">河南德能环保科技有限公司</h4>
              <p className="text-gray-600 mb-6 leading-relaxed">
                创立于2018年3月，是由一群专注于能源数据研究、志在为节能低碳事业奋斗的青年骨干联合发起的创新创业型科技服务公司。公司先后中标2020-2021年国家工信部节能诊断服务机构、2021年河南省用能权第三方审核机构。
              </p>
              <div className="space-y-3">
                <div className="flex items-center text-sm text-gray-600">
                  <i className="ri-check-line text-emerald-500 mr-2"></i>
                  参与地方标准《二氧化碳排放信息报告通则》制订
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <i className="ri-check-line text-emerald-500 mr-2"></i>
                  参与河南省工业领域碳达峰"1+4"实施方案研究
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <i className="ri-check-line text-emerald-500 mr-2"></i>
                  与河南省农业科学院合作共建畜牧行业节能降碳创新实验室
                </div>
              </div>
            </div>
            
            <div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">捷碳（上海）科技有限公司</h4>
              <p className="text-gray-600 mb-6 leading-relaxed">
                2022年3月，在科创板上市公司复洁环保（688335.SH）的支持下正式成立，充分发挥上市公司资本平台优势和上海人才优势，更好地承接国际和国内双碳业务。
              </p>
              <div className="space-y-3">
                <div className="flex items-center text-sm text-gray-600">
                  <i className="ri-check-line text-emerald-500 mr-2"></i>
                  拥有18项软件著作权，2项国家实用新型专利
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <i className="ri-check-line text-emerald-500 mr-2"></i>
                  在广州、郑州、杭州等地建立区域分子公司
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <i className="ri-check-line text-emerald-500 mr-2"></i>
                  打造行业领先的综合性双碳服务商
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Core Business */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">核心业务领域</h3>
            <p className="text-lg text-gray-600">专业从事国际国内双碳服务</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-global-line text-emerald-600 text-xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">国际碳减排项目</h4>
              <p className="text-gray-600 text-sm">CDM、VCS、GS、CCER碳减排项目注册和核查咨询服务</p>
            </div>
            <div className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-exchange-line text-emerald-600 text-xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">减排量交易</h4>
              <p className="text-gray-600 text-sm">购买和交易CDM、VCS、GS、CCER项目核证减排量</p>
            </div>
            <div className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-medal-line text-emerald-600 text-xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">绿证开发交易</h4>
              <p className="text-gray-600 text-sm">开发和交易I-REC国际绿色电力证书</p>
            </div>
            <div className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-pie-chart-line text-emerald-600 text-xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">碳盘查服务</h4>
              <p className="text-gray-600 text-sm">碳盘查、配额交易、管理以及履约服务</p>
            </div>
            <div className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-funds-line text-emerald-600 text-xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">碳基金服务</h4>
              <p className="text-gray-600 text-sm">提供专业的碳基金管理和投资服务</p>
            </div>
            <div className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-earth-line text-emerald-600 text-xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">气候变化咨询</h4>
              <p className="text-gray-600 text-sm">可持续发展、应对气候变化技术支持及咨询服务</p>
            </div>
          </div>
        </div>

        {/* Team Quality */}
        <div className="bg-gradient-to-br from-emerald-50 to-green-50 rounded-3xl p-8 lg:p-12 mb-20">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">团队实力</h3>
            <p className="text-lg text-gray-600">汇聚国内外顶尖人才，打造专业技术团队</p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h4 className="text-xl font-bold text-gray-900 mb-6">教育背景</h4>
              <p className="text-gray-600 mb-6 leading-relaxed">
                公司团队来自于国内外著名大学，包括康奈尔大学、约克大学、复旦大学、武汉大学、同济大学、郑州大学等知名院校。
              </p>
              <div className="grid grid-cols-2 gap-4">
                <div className="text-center p-4 bg-white rounded-lg">
                  <div className="text-2xl font-bold text-emerald-600">80%+</div>
                  <div className="text-sm text-gray-600">核心技术团队硕士及以上</div>
                </div>
                <div className="text-center p-4 bg-white rounded-lg">
                  <div className="text-2xl font-bold text-emerald-600">60%+</div>
                  <div className="text-sm text-gray-600">团队整体研究生学历</div>
                </div>
              </div>
            </div>
            
            <div>
              <h4 className="text-xl font-bold text-gray-900 mb-6">专业经验</h4>
              <p className="text-gray-600 mb-6 leading-relaxed">
                核心团队成员在碳咨询、节能减排和清洁能源等领域具有丰富的从业经历，管理层行业经历均在10年以上。
              </p>
              <div className="space-y-4">
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-user-star-line text-emerald-600"></i>
                  </div>
                  <span className="text-gray-700">核心团队：5-10年专业经验</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-team-line text-emerald-600"></i>
                  </div>
                  <span className="text-gray-700">管理层：10年以上行业经历</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-medal-line text-emerald-600"></i>
                  </div>
                  <span className="text-gray-700">专业领域：碳咨询、节能减排、清洁能源</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Achievements */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">我们的成就</h3>
            <p className="text-lg text-gray-600">用数据说话，见证我们的专业实力</p>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {achievements.map((achievement, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${achievement.icon} text-emerald-600 text-2xl`}></i>
                </div>
                <div className="text-3xl font-bold text-gray-900 mb-2">{achievement.number}</div>
                <div className="text-gray-600">{achievement.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Company Values */}
        <div>
          <div className="text-center mb-16">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">企业价值观</h3>
            <p className="text-lg text-gray-600">指导我们前进的核心理念</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="text-center group hover:transform hover:scale-105 transition-all duration-300">
                <div className="w-20 h-20 bg-gradient-to-br from-emerald-100 to-green-100 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:shadow-lg transition-shadow duration-300">
                  <i className={`${value.icon} text-emerald-600 text-3xl`}></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-4">{value.title}</h4>
                <p className="text-gray-600 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
